import { useGetDefaultSectionConfigsQuery } from '../../__generated__/chirp/com/hubspot/crm/pipeline/board/configuration/rpc/CrmPipelineBoardConfigurationService.hooks';
import { useMemo } from 'react';
import { getFormattedSectionSettings } from './utils';
import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
import { useHasCardV2 } from 'crm-object-board-core/hooks';
import { useSelectedPipelineIdByAccess } from '../hooks/useSelectedPipelineIdByAccess';
import { useAppId } from '../hooks/useAppId';
import { QUOTES_SECTION_DEALS_KANBAN } from 'growth-payments-core/constants/gates';
import { useIsUngatedForCPQFeature } from 'growth-payments-core/auth/gates';
import { QUOTES_ACTION_SECTION_KEY, QUOTES_SECTION_KEY } from '../sections/quotes/types';
import { QUICK_ACTIONS_SECTION_KEY } from '../sections/actions/container/types';
export const getFilteredCardSectionOptions = (settings, isUngatedForQuotesSection) => {
  return settings.reduce((acc, setting) => {
    if (isUngatedForQuotesSection) {
      acc.push(setting);
      return acc;
    }
    if (setting.sectionKey === QUOTES_SECTION_KEY) {
      return acc;
    }
    if (setting.sectionKey === QUICK_ACTIONS_SECTION_KEY) {
      const filteredQuickActions = setting.settings.quickActions.filter(action => action.type !== QUOTES_ACTION_SECTION_KEY);
      acc.push(Object.assign({}, setting, {
        settings: Object.assign({}, setting.settings, {
          quickActions: filteredQuickActions
        })
      }));
      return acc;
    }
    acc.push(setting);
    return acc;
  }, []);
};
export const useDefaultCardSectionSettings = () => {
  const hasCardV2 = useHasCardV2();
  const objectTypeId = useObjectTypeId();
  const pipelineId = useSelectedPipelineIdByAccess();
  const appId = useAppId();
  const {
    loading,
    error,
    data: apiData
  } = useGetDefaultSectionConfigsQuery({
    skip: !hasCardV2,
    variables: {
      pipelineId,
      objectTypeId,
      appId
    }
  });
  const formattedSettings = useMemo(() => {
    var _apiData$boardCardSec;
    return getFormattedSectionSettings((_apiData$boardCardSec = apiData === null || apiData === void 0 ? void 0 : apiData.boardCardSectionConfigurations) !== null && _apiData$boardCardSec !== void 0 ? _apiData$boardCardSec : []);
  }, [apiData]);
  const isUngatedForQuotesSection = useIsUngatedForCPQFeature(QUOTES_SECTION_DEALS_KANBAN);
  const filteredSettings = useMemo(() => getFilteredCardSectionOptions(formattedSettings, isUngatedForQuotesSection), [formattedSettings, isUngatedForQuotesSection]);
  if (error || loading) {
    return {
      data: [],
      loading,
      error
    };
  }
  return {
    data: filteredSettings,
    loading,
    error
  };
};